/** @jsxImportSource @emotion/react */
import {LoaderStyle} from "./style";

const Loading = () => {
    return <div>
        <img
            src="https://www.freeiconspng.com/uploads/file-pokeball-png-0.png"
            alt=""
            css={LoaderStyle}/>
    </div>
}

export default Loading;